<template>
  <div>
    <PageTitle>Overwolf Scrims</PageTitle>
    <ApiLoadingController ref="loadingController" :fetch="getScrims">
      <template #default="{ data }">
        <OWScrimTable :items="data" @deleteScrim="deleteScrim" />
      </template>
    </ApiLoadingController>
    <button v-if="hasMore && matches.length > 0 && !isFetching" @click="retryGetScrims">Load More Scrims</button>
  </div>
</template>

<script>
import OWScrimTable from '@/components/scrim2/OWScrimTable.vue'

import { getOWScrims, deleteMatch } from '../../api/ow-scrims.js'
import ApiLoadingController from '../../components/controllers/ApiLoadingController.vue'
import PageTitle from '../../components/generic/PageTitle.vue'

const limit = 20

export default {
  name: 'OWScrimList',
  components: { PageTitle, ApiLoadingController, OWScrimTable },
  data() {
    return {
      matches: [],
      offset: 0,
      isFetching: false,
      hasMore: true,
    }
  },
  methods: {
    async getScrims() {
      if (this.isFetching || !this.hasMore) return

      this.isFetching = true

      let scrims = await getOWScrims(this.offset, limit + 1)
      if (scrims.length <= limit) {
        this.hasMore = false
      } else {
        this.offset++
        scrims.pop()
      }

      this.matches = [...this.matches, ...scrims]

      this.isFetching = false
      return this.matches
    },
    retryGetScrims() {
      this.$refs.loadingController.retry()
    },
    async deleteScrim(scrim) {
      await deleteMatch(scrim.id)
      this.offset = 0
      this.hasMore = true
      this.matches = []
      this.$refs.loadingController.retry()
    },
  },
}
</script>

<style scoped></style>
